import { Col, Row } from 'antd';
import clsx from 'clsx';
import { FC } from 'react';
import styles from './styles.module.less';

interface StaticPageContainerProps {
  className?: string;
  size?: 'xl' | 'lg' | 'md';
}

const StaticPageContainer: FC<StaticPageContainerProps> = ({ className, size = 'md', children }) => {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <Row justify="center">
        <Col xs={23}>
          <div className={clsx(styles.container, styles[size])}>{children}</div>
        </Col>
      </Row>
    </div>
  );
};

export default StaticPageContainer;
